import { Injectable, OnDestroy, Directive, Optional } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';

import { SharedService } from '@services/shared.service';

import { ComponentBase } from './component-base.component';

@Directive()
@Injectable()
export class PageBase extends ComponentBase implements OnDestroy {

    public isDesktop = false;

    constructor(public location: Location,
        public router: Router,
        public sharedService: SharedService,
        @Optional() breakpointObserver?: BreakpointObserver) {
        super(router);

        sharedService.setCurrentView(this);
        sharedService.setPageBack(false); // no visible
        sharedService.setMainPageBack(false); // no visible
        sharedService.setHideLoginBtn(false); // no visible
        sharedService.setPageLogo(`assets/images/logo-givi.png`, false);

        // valida si es desktop
        if (breakpointObserver) {
            breakpointObserver
                .observe(['(max-width: 1024px)'])
                .subscribe((state: BreakpointState) => {
                    if (state.matches) {
                        this.isDesktop = false;
                    } else {
                        this.isDesktop = true;
                    }
                });
        }
    }

    ngOnDestroy() {

        this.sharedService.setCurrentView(null);
    }

    public allowNavigate(): Promise<boolean> {

        return this._allowNavigate();
    }

    public onCancel(): void {

        this._allowNavigate().then(
            (result: boolean) => {

                if (result) {

                    if (this.location) {
                        this.location.back();
                    }
                }
            }
        );
    }

    onPrint() {

        window.print();
    }
}
